import React from 'react'
import PropTypes from 'prop-types'

import { ReviewEntry } from '../'
import './ToolDetailReviews.sass'


const ToolDetailReviews = (props) => {
  const { toggleReviewOverlay, reviews } = props

  return (
    <section className="tool-detail-reviews">
      <div className="header">
        <h4>Community Reviews</h4>
        <p>(Total {reviews.length})</p>
        <button type="button" className="btn-transparent-sm" onClick={toggleReviewOverlay}>review tool</button>
      </div>
      <div>
        {reviews.map((review, idx) => <ReviewEntry key={idx} review={review} />)}
      </div>
    </section>
  )
}

ToolDetailReviews.propTypes = {
  toggleReviewOverlay: PropTypes.func.isRequired,
  reviews: PropTypes.array
}

export default ToolDetailReviews
